import { createTheme } from '@one-thd/sui-atomic-components';

const SummerSecondaryOrange = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

SummerSecondaryOrange.palette['--sui-palette-background-primary'] = '250 140 69';

export { SummerSecondaryOrange };
